import React, { useState } from "react";
import { salas } from '../../../../service/services/Salas.service';
import { Loading } from '../../../../components/common/Loading/Loading';
import { Form, Formik } from 'formik';
import { Divider, Grid, TextField, Typography, Tooltip } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Snackbar, Alert } from '@mui/material';
import { KEY_EMPRESA, KEY_USER_DATA } from "@/toolbox/constants/local-storage";
import { readLocalStorage } from "@/toolbox/helpers/local-storage-helper";

export const AddSala: React.FC<any> = (props:any): JSX.Element => {
  
    const {onListSala, closeModal, sala} = props;
    const [loadData,setLoadData] = React.useState<boolean>(false);
    // eslint-disable-next-line
    const [data, setData] = useState({
        id : sala && sala.id ? sala.id : 0,
        nombre: sala && sala.nombre ? sala.nombre : '',
        mesas:  sala && sala.mesas ? sala.mesas: 0,
        state: sala && sala.state ? sala.state : '',
    });

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });

    const SessionUser: any = readLocalStorage(KEY_USER_DATA);
    const idSucursal = SessionUser.user?.id_sucursal;

    const validateForm = (values) => {
        let errors: any = {};

        if(!values.nombre) errors.nombre = "nombre requerido";
        if(!values.mesas) errors.mesas = "cantidad requerido";

        return errors;
    }

    const onSubmit = async(values, {resetForm}) =>{
        const state = 1;
        setLoadData(true);
        let urlMesa = window.location.origin;
        if(sala){
            await salas.editSala(values.id, values.nombre, values.mesas, values.state).then((data) => {
                setLoadData(false);
                if (data && data.data) {
                    onListSala && onListSala();
                    closeModal();
                }
             })
        }else{
            await salas.addSala(values.nombre, state, values.mesas, urlMesa, idSucursal).then((data)=>{
                if(data.status === 400){
                    setSnackBarConfig(prev => ({
                        ...prev,
                        open: true,
                        message: `${data.error}`,
                    }));
                }else{
                    onListSala && onListSala();
                    closeModal();
                }
            });
        }
        setLoadData(false);
    }

    return(
        <div className="container">
            {loadData && <Loading/>}

            <Snackbar
                open={snackBarConfig.open}
                autoHideDuration={snackBarConfig.autoHideDuration}
                onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                <Alert
                onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
                severity={snackBarConfig.severity}
                variant="filled"
                >
                {snackBarConfig.message}
                </Alert>
            </Snackbar>

            <Formik enableReinitialize initialValues={data} validate={ (values) => validateForm(values) } onSubmit={onSubmit}>

            {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                return (
                    <Form onSubmit={handleSubmit}>
                        <Grid container spacing={3} alignItems="center" justifyContent="center">

                        <Grid item xs={12} container style={{display: "flex", alignItems: "center"}}>
                            <Grid item xs={4}>
                                <Typography variant="subtitle1" className="custom-input"><b>Nombre:</b></Typography>
                            </Grid>
                            <Grid item xs={8} style={{display: 'flex', alignItems: "center"}}>
                                {
                                    errors.nombre && touched.nombre ? true : false && (
                                        <Tooltip title={errors.nombre}>
                                            <PriorityHighIcon className={'iconWarning'}/>
                                        </Tooltip>
                                    )
                                }
                                <TextField
                                id="nombre"
                                type="text"
                                name="nombre"
                                fullWidth
                                value={values.nombre}
                                onChange={handleChange}
                                placeholder="Nombre de la sala"
                                error={errors.nombre && touched.nombre ? true : false}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} container style={{display: "flex", alignItems: "center"}}>
                            <Grid item xs={4}>
                                <Typography variant="subtitle1" className="custom-input"><b>N° de Mesas:</b></Typography>
                            </Grid>
                            <Grid item xs={8} style={{display: 'flex', alignItems: "center"}}>
                                {
                                    errors.mesas && touched.mesas ? true : false && (
                                        <Tooltip title={errors.mesas}>
                                            <PriorityHighIcon className={'iconWarning'}/>
                                        </Tooltip>
                                    )
                                }
                                <TextField
                                disabled = {sala ? true : false}
                                id="mesas"
                                type="number"
                                name="mesas"
                                fullWidth
                                value={values.mesas}
                                onChange={handleChange}
                                placeholder="cantidad"
                                error={errors.mesas && touched.mesas ? true : false}
                                />
                            </Grid>
                        </Grid>

                        </Grid>
                        <Divider sx={{ my: 2 }} />

                        <div className="form-group mb-3 buton_container_modal">
                            <button type="submit" className="btn btn-primary">
                            {sala ? "Editar Sala" : "Agregar Sala"}
                            </button>
                        </div>

                    </Form>
                )
            }}

            </Formik>
  </div>
    )
}
